import React from 'react';
import { DatePicker, Button, Table, message, ConfigProvider , Space } from 'antd';
import { RightOutlined, CheckCircleTwoTone } from '@ant-design/icons';
import { APIService } from '../../../services/appraisement/api';
import { CalendarTimeService } from '../../../services/calendar/calendar.tool.service.js';
import { CodeOutlined, PlusOutlined, EditOutlined, DeleteOutlined, ReloadOutlined, CloudDownloadOutlined } from '@ant-design/icons';
import Valuation from "../Valuation/Valuation.jsx"
import locale from 'antd/es/date-picker/locale/zh_CN';
import erdsDialog from '../../../lib/editableDialog';
import { __waterDocumentSvg } from '../../../lib/waterMarking.js';
import { returnIframeUrl } from "../../../lib/http";
import zhCN from 'antd/es/locale/zh_CN';
import 'antd/dist/antd.css';
import './ValuationToSee.scss'

import 'moment/locale/zh-cn';
import moment from 'moment';
moment.locale('zh-cn'); // 国际化
const { RangePicker } = DatePicker;

class ValuationToSee extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedRowKeys: [], // 勾选中的下标
            ids: [],
            loading: false,
            projectNumber: this.props.data.data.f6,
            listData: [],
            showSpin: true,
            startDate: "",
            DateClosed: ""
        }
    };

    componentDidMount() {
        // const userInfo = window.config.sysConfig.userInfo;
        // __waterDocumentSvg({
        //     container: document.getElementById('valuation_to_see'),
        //     content: `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
        //     width: '700px',
        //     height: '550px',
        //     opacity: '0.1',
        //     fontSize: '26px',
        //     zIndex: 1000
        // })
        this.getValuation()
    }

    // 点击勾选
    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys: selectedRowKeys });
    };

    // 估值查看列表
    getValuation = () => {
        let { projectNumber, startDate, DateClosed } = this.state
        let { data } = this.props
        this.setState({ listData: data.listData , showSpin:data.showSpin})
    }

    queryTime = () => {
        let { projectNumber, startDate, DateClosed } = this.state

        this.setState({ showSpin: true })

        let param = {
            project_number: projectNumber,
            project_start_time: startDate,
            project_end_time: DateClosed,
        }

        APIService.getValuationListData(param).then(res => {
            if (res.success) {
                console.log(res, "估值查看")
                this.setState({ listData: res.data, showSpin: false })
            } else {
                message.error(res.error);
            }
        }).catch(err => {
            console.log('项目列表接口 Error', err)
        })
    }

    // 估值页跳转到详情
    ValuationsJump = (item) => {
        console.log(item, "item")

        let data = {
            f5: item.project_name,
            f6: item.project_num,
            f7: item.project_date,
            NotOptional: 1,
        }
        console.log(data, "data")

        let details = erdsDialog
        details.show({
            title: '估值详情',
            el: Valuation,
            iszoom:true,
            data: data,
            className: "details"
        })
    }

    // 估值表查询下载接口
    exportExcel = (item) => {

        let param = {
            product_project_number: item.project_num,
            product_business_date: item.project_date,
        }

        let url = returnIframeUrl('/citic/get_download_Valuation_excel/', param);
        let aElement = document.createElement('a'); //创建节点
        document.body.appendChild(aElement);
        aElement.style.display = 'none';
        aElement.href = url;
        aElement.click();
        document.body.removeChild(aElement);
    };

    // 估值表批量下载接口
    BatchDownload = () => {
        let { selectedRowKeys, listData } = this.state
        this.setState({ loading: true })

        let ids = []
        selectedRowKeys.map((item, index) => {
            ids.push(listData[item].row_id)
        })
        if(ids.length == 0){
            message.error('请先勾选要下载的数据!');
            this.setState({ loading: false })
        }else if (ids.length > 50) {
            message.error('当前下载条数超过50,请重新勾选');
            this.setState({ loading: false })
        } else {
            // 项目管理
            let param = {
                row_id: JSON.stringify(ids),
            }

            let url = returnIframeUrl('/citic/get_download_Valuation_excel/', param);
            let aElement = document.createElement('a'); //创建节点
            document.body.appendChild(aElement);
            aElement.style.display = 'none';
            aElement.href = url;
            aElement.click();
            document.body.removeChild(aElement);

            setTimeout(() => {
                this.setState({
                    selectedRowKeys: [],
                    loading: false
                });
            }, 1000);
        }

    }

    render() {
        const { loading, selectedRowKeys, listData, showSpin } = this.state;

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange
        };
        const hasSelected = selectedRowKeys.length > 0;

        const columns = [
            {
                title: "项目简称",
                align: "center",
                dataIndex: "name",
                width: 250,
            },
            {
                title: "项目编号",
                dataIndex: "serial",
                align: "center",
                width: 200,
            },
            {
                title: "估值日期",
                dataIndex: "section",
                align: "center",
                width: 150,
            },
            {
                title: "估值表状态",
                dataIndex: "sheet",
                align: "center",
                width: 150,
            },
            {
                title: "确认日期",
                dataIndex: "confirmation",
                align: "center",
                width: 150,
            },
            // {
            //     title: "查看",
            //     align: "center",
            //     dataIndex: "address",
            //     width: 100,
            // },
            {
                title: "操作",
                align: "center",
                dataIndex: "operation",
                width: 200,
            }
        ];

        const data = [];

        listData.map((item, index) => {
            data.push({
                key: index,
                name: item.project_name,
                serial: item.project_num,
                section: item.project_date,
                sheet: item.project_static,
                confirmation: item.confirmation_date,
                operation: <div>
                    <Button
                        style={{ margin: '0 10px' }} type="primary"
                        onClick={() => { this.ValuationsJump(item) }}
                        size="small"
                    >
                        查看
                    </Button>
                    <Button
                        style={{ margin: '0 10px' }} type="primary"
                        onClick={() => { this.exportExcel(item) }}
                        size="small"
                    >
                        下载
                    </Button>
                </div>
            });
        })

        return (
            <ConfigProvider locale={zhCN}>
                <div id="valuation_to_see">
                    <div className="Performance">
                        <div className="box">
                            <div className="batch-Download">
                                <Button
                                    type="primary"
                                    onClick={() => this.BatchDownload()}
                                    // disabled={!hasSelected}
                                    loading={loading}
                                >
                                    批量下载
                                </Button>
                                <span className="pitch">
                                    {hasSelected ? `已选中 ${selectedRowKeys.length} 条` : ""}
                                </span>
                            </div>
                            <div style={{ width: "700px" }} className="Inquire">
                                    估值日期：
                                    <RangePicker
                                        autoFocus={false}
                                        locale={locale}
                                        getPopupContainer={triggerNode => triggerNode.parentElement}
                                        style={{ marginRight: "10px" }}
                                        onChange={(a, e) => {
                                            this.setState({ startDate: e[0], DateClosed: e[1] })
                                        }}
                                    />
                                    <Button
                                        type="primary"
                                        onClick={() => { this.queryTime() }}
                                    >
                                        查询
                                    </Button>
                                </div>
                            <Table
                                key={`${data}`}
                                size="small"
                                loading={showSpin}
                                className="Performance-Tab"
                                rowSelection={rowSelection}
                                columns={columns}
                                dataSource={data}
                                pagination={{
                                    showSizeChanger :false,
                                    showTotal: (total, range) => 
                                    <Space>
                                        <span>共 {total} 条 </span>
                                    </Space>,
                                }}
                                rowClassName={(record, index) => {
                                    let className = 'dark-row';
                                    if (index % 2 === 1) className = 'light-row';
                                    return className;
                                }}
                                scroll={{
                                    y: 530
                                }}
                            />
                        </div>
                    </div>
                </div>
            </ConfigProvider>

        )
    }
}
export default ValuationToSee;


// WEBPACK FOOTER //
// app/components/customPage/ValuationToSee/ValuationToSee.jsx